module.exports = __webpack_public_path__ + "static/media/77caabd3-1877-4634-85c8-8e398a093b99.e541e48f.woff2";